import profile from "./profile-reducer";
import events from "./events-reducer";

export default {
    profile,
    events,
};
  